import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textCapsObj } = typographyStyles;

const neutral400 = colors.ui.neutral[400];

export const collapseBtnCss = {
  Button: {
    root: { width: "100%" },
  },
};
export const headerSectionCss = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
};

export const elaTitleCss = {
  color: neutral400,
  fontSize: "12px",
  ...textCapsObj,
};
